<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-row class="mt-2">
            <v-col cols="2">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div  @click="actualizar()" class="mt-n2">
                            <v-chip color="indigo" dark>Actualizar Pedidos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-chip>
                            <v-btn class="ml-n5" color="indigo" fab small dark><v-icon>refresh</v-icon></v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <v-list>
                            <v-list-item-group color="primary">
                                <v-divider></v-divider>
                                <div v-for="item in portales" :key="item.id">
                                    <v-list-item @click="selectPortal(item)">
                                        <v-list-item-avatar>                                           
                                            <img :src="item.logo" />
                                        </v-list-item-avatar>
                                    <v-list-item-content>
                                        <span class="text-body-2">{{item.name}}</span>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                        <v-btn color="indigo" fab small dark>{{ item.total }}</v-btn>
                                        <v-icon>chevron_right</v-icon>
                                    </v-list-item-icon>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                </div>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="10">
                <v-row>
                    <v-col cols="6">
                        <h3>COMERCIO:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="teal--text">{{ comercio }}</span></h3>
                        <v-simple-table fixed-header height="250" dense class="myborder">
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Fecha</th>
                                    <th id="back" class="text-start">Orden</th>
                                    <th id="back" class="text-center">Total</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="detailOrder(item)" v-for="item in myorders" :key="item.id">
                                    <td class="text-center">
                                        <span>{{ item.fecha }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span>{{ item.orden }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span>$ {{ new Intl.NumberFormat('de-DE').format(item.total) }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon color="red" small>chevron_right</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="6">
                        <v-row class="mt-n5">
                            <v-col cols="12">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <h3>FACTURACIÓN:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="teal--text">{{ dte }}</span></h3>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-btn color="teal" block rounded dark x-small>emitir</v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-btn color="teal" block rounded dark x-small>subir</v-btn>
                                        </v-col>
                                        <v-col cols="12" class="mt-n5">
                                            <v-divider></v-divider>
                                            <h5>Rut: <span class="teal--text">{{rut_factura}}</span></h5>
                                            <h5>Razon Social: <span class="teal--text">{{razon_factura}}</span></h5>
                                            <h5>Direccion: <span class="teal--text">{{direccion_factura}}</span></h5>
                                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_factura}}</span></h5>
                                            <!-- <h5>Giro: <span class="teal--text">{{giro_factura}}</span></h5> -->
                                            <h5>Email: <span class="teal--text">{{email_factura}}</span></h5>
                                        </v-col>
                                    </v-row>                                
                                </v-container>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="12">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6">
                                            <h3>DESPACHO:</h3>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-btn color="teal" block rounded dark x-small>etiqueta</v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-btn color="teal" block rounded dark x-small>manifiesto</v-btn>
                                        </v-col>
                                        <v-col cols="12" class="mt-n5">
                                            <v-divider></v-divider>
                                            <h5>Contacto: <span class="teal--text">{{contacto_despacho}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                Email: <span class="teal--text">{{email_despacho}}</span>
                                            </h5>
                                            <h5>Dirección: <span class="teal--text">{{direccion_despacho}}</span></h5>
                                            <h5>Comuna - Ciudad: <span class="teal--text">{{comuna_despacho}}</span></h5>
                                            <h5>Transporte: <span class="teal--text">{{transporte}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                Peso (kg): <span class="teal--text">{{new Intl.NumberFormat('de-DE').format(peso)}}</span>&nbsp;&nbsp;
                                                Vol. (cm3): <span class="teal--text">{{new Intl.NumberFormat('de-DE').format(volumen)}}</span>    
                                            </h5>
                                            <h5>Costo ($): <span class="teal--text">{{new Intl.NumberFormat('de-DE').format(costo)}}</span></h5>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="mt-n5">
                    <v-col cols="12">
                        <h3>DETALLE DE LA ORDEN:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="teal--text">{{ pedido }}</span></h3>
                        <v-simple-table fixed-header height="120" dense class="myborder">
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Sku</th>
                                    <th id="back" class="text-start">Producto</th>
                                    <th id="back" class="text-start">Variante</th>
                                    <th id="back" class="text-end">Precio</th>
                                    <th id="back" class="text-center">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in myproducts" :key="item.id">
                                    <td class="text-center">
                                        <span>{{ item.sku }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span>{{ item.producto }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span>{{ item.variante }}</span>
                                    </td>
                                    <td class="text-end">
                                        <span>$ {{ new Intl.NumberFormat('de-DE').format(item.precio) }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span>{{ new Intl.NumberFormat('de-DE').format(item.cantidad) }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-container>
            <v-row class="mt-3">
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        <v-btn @click="clsInfo()" color="teal" rounded dark small block>Nuevo</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="teal" rounded dark small block>Integrar</v-btn>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
        </v-container>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>

        <v-dialog v-model="dialog" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<style>
#back {
    background-color: lightblue;
}
.myborder {
    border:1px solid grey;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Ecommerce',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    dialog:false,

    comercio:'',
    pedido:'',
    dte:'',
    myorders:[],
    myinvoice:[],
    myshipping:[],
    array_products:[],
    myproducts:[],

    rut_factura:'',
    razon_factura:'',
    giro_factura:'',
    email_factura:'',
    fono_factura:'',
    region_factura:'',
    direccion_factura:'',
    comuna_factura:'',
    ciudad_factura:'',

    contacto_despacho:'',
    email_despacho:'',
    fono_despacho:'',
    region_despacho:'',
    direccion_despacho:'',
    comuna_despacho:'',
    ciudad_despacho:'',
    transporte:'',
    peso:'',
    volumen:'',
    costo:0,

    portales:[],
    ordenes:[],
    bloqueo:null,
    hoy: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

  }),
  async mounted(){
    this.dialog=true;
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.bloqueo = await this.myPermiso(11);
    console.log(this.bloqueo);
    if(this.bloqueo!=0 && this.bloqueo!=null){
        await this.searchPortals();
        if(this.portales.length!=0){
            //await this.searchOrders();
            await this.Orders(1);

        };
    }
    this.dialog=false;
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async actualizar(){
        this.dialog=true;
        this.clsInfo();
        await this.searchPortals();
        if(this.portales.length!=0){
            await this.searchOrders();
        }
        this.dialog=false;
    },
    async searchPortals(){
        try {
            this.portales=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                portal :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/portals/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.portales.push({
                        id: element.id,
                        portal: element.portal,
                        name: element.name,
                        logo: element.logo,
                        total: 0
                    })                    
                });
            }           
        } catch (error) {
            console.log(error)
        }
    },


    async obtener_credenciales(my_portal){
        let result = {};
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato: this.contrato,
                user: this.user,
                portal: my_portal
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/api_credencial/',params,{headers});
            const datos = res.data;
            console.log(datos)
            if(datos[0].existe=='si'){
                const json_credencial = JSON.parse(datos[0].credenciales);
                result = json_credencial;
            }
        } catch (error) {
            console.log(error)
        };
        return result
    },
    //buscar ordenes del dia
    async Orders(my_portal){
        //obtener fechas para consultas
        var hoy = new Date();
        var ahora = (new Date(hoy - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        ahora = ahora + 'T00:00:00';
        var desde = new Date(hoy.getTime() - (24 * 60 * 60 * 1000));
        desde = (new Date(desde - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        desde = desde + 'T00:00:00';
        var hasta = new Date(hoy.getTime() + (24 * 60 * 60 * 1000));
        hasta = (new Date(hasta - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        hasta = hasta + 'T00:00:00';
        var despues = new Date(hoy.getTime() - (24 * 60 * 60 * 1000));
        despues = (new Date(despues - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        despues = despues + 'T00:00:00';
        var antes = new Date(hoy.getTime() + (24 * 60 * 60 * 1000));
        antes = (new Date(antes - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        antes = antes + 'T00:00:00';
        //obtener las credenciales del portal
        const my_credenciales = await this.obtener_credenciales(my_portal);
        if(my_credenciales.length!=0){
            try {
                switch (my_portal) {
                    case 1: //falabella
                    await this.orders_falabella(my_credenciales, despues, antes)

                    break;
                }
                
            } catch (error) {
                console.log(error)
            }
        }


    },
    async orders_falabella(credenciales, despues, antes){
        try {
            //obtener la url
            const params = {
                contrato: this.contrato,
                user: this.user,
                parameters:{
                    user_id: credenciales.user_id,
                    action: "GetOrders",
                    Api_key: credenciales.api_key,
                    date_after: despues,
                    date_before: antes,
                    // date_after: "2025-01-25T00:00:00",
                    // date_before: "2025-01-31T00:00:00",
                }
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/falabella/get_orders/',params);
            const datos = res.data;
            if(datos[0].existe=='si'){
                const url = await this.url_falabella(datos[0].data);
                console.log(url);
                const data = await this.getOrder_falabella(url);
                console.log(data);
            }
           
        } catch (error) {
            console.log(error)
        }
 
    },
    async url_falabella(parameters){
        // example:
        var url = "https://sellercenter-api.falabella.com/";
        var qs = "";
        for(var key in parameters) {
            var value = parameters[key];
            qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
        }
        if (qs.length > 0){
            qs = qs.substring(0, qs.length-1); //chop off last "&"
            url = url + "?" + qs;
        }
        //console.log(url);
        // => http://www.example.com/?name=George%20Washington&dob=17320222
        return url;
    },
    async getOrder_falabella(url){
        let result;
        try {
            const res = await axios.get(url);
            const datos = res.data;
            result = datos;
        } catch (error) {
            console.log(error)
        }
        return result
    },






    async searchOrders(){
        this.ordenes=[];
        let order=[];
        let invoice=[];
        let shipping=[];
        let products=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            let res;
            let datos;
            for (let index = 0; index < this.portales.length; index++) {
                const element = this.portales[index];
                const portal = element.portal;
                //parametros por portal
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    portal :  portal,
                    estado : 'V'
                };
                //buscar orders
                order=[];
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/orders_ecommerce/',params,{headers});
                datos = res.data;
                if(datos[0].existe=='si'){
                    order = datos;
                };
                //buscar invoice
                invoice=[];
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/invoice_ecommerce/',params,{headers});
                datos = res.data;
                if(datos[0].existe=='si'){
                    invoice = datos;
                };
                //buscar shipping
                shipping=[];
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/shipping_ecommerce/',params,{headers});
                datos = res.data;
                if(datos[0].existe=='si'){
                    shipping = datos;
                };
                //buscar products
                products=[];
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/products_ecommerce/',params,{headers});
                datos = res.data;
                if(datos[0].existe=='si'){
                    products = datos;
                };
                //insertamos en el array
                this.ordenes.push({
                    portal: portal,
                    order: order,
                    invoice: invoice,
                    shipping: shipping,
                    products: products
                });
                //asignamos el total al portal
                const pending = order.length;
                if(pending!=0){
                    const found = this.portales.filter( res => res.portal == portal);
                    if(found.length!=0){
                        found[0].total = pending
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async selectPortal(item){
        this.clsInfo();
        this.comercio=item.name;
        if(parseInt(item.total)!=0){
            //listamos las ordenes del portal
            const data = this.ordenes.filter( res => res.portal == item.portal);
            this.myorders = data[0].order;
            this.myinvoice = data[0].invoice;
            this.myshipping = data[0].shipping;
            this.array_products = data[0].products;
        }
    },
    async detailOrder(item){
        //invoice
        this.pedido=item.orden;
        const data_invoice = this.myinvoice.filter( res => res.portal == item.portal && res.orden == item.orden);
        if(data_invoice.length!=0){
            const element_invoice = data_invoice[0];
            this.dte=element_invoice.dte;
            this.rut_factura=element_invoice.rut;
            this.razon_factura=element_invoice.razon;
            this.giro_factura=element_invoice.giro;
            this.email_factura=element_invoice.email;
            this.fono_factura=element_invoice.fono;
            this.region_factura=element_invoice.region;
            this.direccion_factura=element_invoice.direccion;
            this.comuna_factura=element_invoice.comuna;
            this.ciudad_factura=element_invoice.ciudad;
        };
        //shipping
        const data_shipping = this.myshipping.filter( res => res.portal == item.portal && res.orden == item.orden);
        if(data_shipping.length!=0){
            const element_shipping = data_shipping[0];
            this.contacto_despacho=element_shipping.nombre;
            this.email_despacho=element_shipping.email;
            this.fono_despacho=element_shipping.fono;
            this.region_despacho=element_shipping.region;
            this.direccion_despacho=element_shipping.direccion;
            this.comuna_despacho=element_shipping.comuna;
            this.ciudad_despacho=element_shipping.ciudad;
            this.transporte=element_shipping.transporte;
            this.peso=element_shipping.peso;
            this.volumen=element_shipping.volumen;
            this.costo=element_shipping.costo;
        };
        //products
        const data_products = this.array_products.filter( res => res.portal == item.portal && res.orden == item.orden);
        if(data_products.length!=0){
            this.myproducts = data_products;
        }
    },
    clsInfo(){
        this.comercio='';
        this.pedido='';
        this.dte='';
        this.myorders=[];
        this.myinvoice=[];
        this.myshipping=[];
        this.array_products=[];
        this.myproducts=[];
        this.rut_factura='';
        this.razon_factura='';
        this.giro_factura='';
        this.email_factura='';
        this.fono_factura='';
        this.region_factura='';
        this.direccion_factura='';
        this.comuna_factura='';
        this.ciudad_factura='';

        this.contacto_despacho='';
        this.email_despacho='';
        this.fono_despacho='';
        this.region_despacho='';
        this.direccion_despacho='';
        this.comuna_despacho='';
        this.ciudad_despacho='';
        this.transporte='';
        this.peso='';
        this.volumen='';
        this.costo=0;
    }

  }
}
</script>